/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { url } from 'utils/urls';
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/logo/partner/partner_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:false});


/* ========== ~~~~~~~~~~ LOGO : PARTNER ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const PartnerLogo = (props) => {
	let elSettings = props.embedSettings.elements.partnerLogo;
	if(!elSettings.src) return null;
    let inlineStyles = { 'background-image': `url(${url.image.client}${elSettings.src})` };
	function handleClick(e) {
		// // ::: tracking: logo click ::: //
        trackEvent({ type: 'click', name: 'ceuClicks', target: 'logo', additionalProps: {logo: {type: 'partner', brand: elSettings.text, url: elSettings.url, frame: props.frameData}}});
        // refresh advertisements
        refreshAds();
    }
    function isValidURL() {
        return !(elSettings.url === undefined || elSettings.url === null || elSettings.url === '');
    }
    return(
		<a className={`logo partner ${sheet.classes.partner} clickable-${isValidURL()}`} href={`${elSettings.url}`} target="_blank" onClick={handleClick} style={inlineStyles}><span className={`accessibility`}>${elSettings.text}</span></a>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default PartnerLogo;
